import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'

const ELLIPSIS = 'ellipsis'
const START_BLOCK_SIZE = 3
const MIDDLE_WINDOW_SIZE = 3
const END_BLOCK_SIZE = 3

const BUTTON_CLASS = 'btn btn-primary btn-s lg:btn-m btn-square hover:z-2'

export function getPageNumbers(activePage, totalPages) {
  if (totalPages <= START_BLOCK_SIZE + 1) {
    return Array.from({ length: totalPages }, (_, i) => i + 1)
  }

  const pages = [1]
  const startThreshold = START_BLOCK_SIZE
  const endThreshold = totalPages - END_BLOCK_SIZE + 1

  if (activePage < startThreshold) {
    for (let i = 2; i <= Math.min(START_BLOCK_SIZE, totalPages); i++) pages.push(i)
    if (totalPages > START_BLOCK_SIZE) {
      pages.push(ELLIPSIS)
      pages.push(totalPages)
    }
    return pages
  }

  if (activePage >= endThreshold) {
    const left = Math.max(2, totalPages - END_BLOCK_SIZE + 1)
    pages.push(ELLIPSIS)
    for (let i = left; i <= totalPages; i++) pages.push(i)
    return pages
  }

  const left = Math.max(2, activePage - (MIDDLE_WINDOW_SIZE - 1))
  const right = Math.min(totalPages - 1, left + MIDDLE_WINDOW_SIZE - 1)
  pages.push(ELLIPSIS)
  for (let i = left; i <= right; i++) pages.push(i)
  pages.push(ELLIPSIS)
  pages.push(totalPages)
  return pages
}

export function PaginationControls({ activePage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null

  const pageNumbers = getPageNumbers(activePage, totalPages)

  const goToPage = (page) => {
    if (page === activePage) return
    onPageChange(page)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="flex w-full items-center justify-center">
      <div className="flex items-center py-2">
        <button
          type="button"
          className={clsx(BUTTON_CLASS, 'btn-border -mr-px')}
          onClick={() => goToPage(activePage - 1)}
          disabled={activePage <= 1}
          aria-label="Previous page"
        >
          <div className="w-[6px] h-[11px] children:size-full">
            <Icon id="chevron-left" />
          </div>
        </button>
        {pageNumbers.map((page, index) =>
          page === ELLIPSIS ? (
            <span key={`ellipsis-${index}`} className={clsx(BUTTON_CLASS, 'btn-border -mr-px pointer-events-none')}>...</span>
          ) : (
            <button
              key={page}
              type="button"
              className={clsx(BUTTON_CLASS, '-mr-px', page === activePage ? 'btn-fill z-3' : 'btn-border')}
              onClick={() => goToPage(page)}
              aria-label={`Page ${page}`}
              aria-current={page === activePage ? 'page' : undefined}
            >
              <span>{page}</span>
            </button>
          )
        )}
        <button
          type="button"
          className={clsx(BUTTON_CLASS, 'btn-border')}
          onClick={() => goToPage(activePage + 1)}
          disabled={activePage >= totalPages}
          aria-label="Next page"
        >
          <div className="w-[6px] h-[11px] children:size-full">
            <Icon id="chevron-right" />
          </div>
        </button>
      </div>
    </div>
  )
}
